module.exports = __webpack_public_path__ + "assets/img/4.b2948e9b.png";